// extracted by mini-css-extract-plugin
export default {"announcementBar":"os8ScznKFaH5oBi_MqJZ"};